var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSave01 = function SvgSave01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.5 6.212v13.48q0 .758-.525 1.283t-1.283.525H4.308q-.758 0-1.283-.525a1.75 1.75 0 0 1-.525-1.283V4.308q0-.758.525-1.283T4.308 2.5h13.48zM20 6.85 17.15 4H4.308a.3.3 0 0 0-.221.087.3.3 0 0 0-.087.22v15.385a.3.3 0 0 0 .087.221.3.3 0 0 0 .22.087h15.385a.3.3 0 0 0 .221-.087.3.3 0 0 0 .087-.22zm-6.23 9.689a2.4 2.4 0 0 0 .73-1.77A2.4 2.4 0 0 0 13.77 13a2.4 2.4 0 0 0-1.77-.73 2.4 2.4 0 0 0-1.77.73 2.4 2.4 0 0 0-.73 1.77q0 1.038.73 1.768a2.4 2.4 0 0 0 1.77.731 2.4 2.4 0 0 0 1.77-.73M5.384 8.883H14.5v-3.5H5.385z"
  })));
};
export default SvgSave01;